// extracted by mini-css-extract-plugin
export default {"box":"DefaultPlanHelper_box__Huwyg"};